import { useState } from 'react';
import { useLocalStorage } from './useLocalStorage';
import { Risk } from '../types/risk';
import { sampleRisks } from '../data/sampleData';

export function useRisks(dealId?: string) {
  const [risks, setRisks] = useLocalStorage<Risk[]>('risks', sampleRisks);
  const [loading, setLoading] = useState(false);

  const filteredRisks = dealId
    ? risks.filter(risk => risk.dealId === dealId)
    : risks;

  const addRisk = async (risk: Omit<Risk, 'id' | 'createdAt' | 'updatedAt'>) => {
    setLoading(true);
    try {
      const newRisk: Risk = {
        ...risk,
        id: crypto.randomUUID(),
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      setRisks([...risks, newRisk]);
      return newRisk;
    } finally {
      setLoading(false);
    }
  };

  const updateRisk = async (riskId: string, updates: Partial<Risk>) => {
    setLoading(true);
    try {
      setRisks(risks.map(risk =>
        risk.id === riskId
          ? { ...risk, ...updates, updatedAt: new Date().toISOString() }
          : risk
      ));
    } finally {
      setLoading(false);
    }
  };

  const deleteRisk = async (riskId: string) => {
    setLoading(true);
    try {
      setRisks(risks.filter(risk => risk.id !== riskId));
    } finally {
      setLoading(false);
    }
  };

  return {
    risks: filteredRisks,
    loading,
    addRisk,
    updateRisk,
    deleteRisk
  };
}